import { cacheTypes, getMethod, getMethodByCallBack, postMethod, postMethodByCallBack } from "../../../store/api/CommonFunctions";

export function getInfoTypeList(onGet)
{
    getMethodByCallBack('api/BaseInfoAPI/GetInfoTypeList',cacheTypes.NoCache, onGet, "GetInfoTypeList");
}
/**
 * 
 * @param {bigint} typeID 
 * @param {function} onGet 
 */
export function getBaseInfoList(typeID, onGet)
{
    getMethodByCallBack(`api/BaseInfoAPI/GetBaseInfoList?typeID=${typeID}`, cacheTypes.NoCache, onGet, "GetBaseInfoList");
}
export function addBaseInfo(data, onAdd)
{
    postMethodByCallBack(`api/BaseInfoAPI/AddBaseInfo`, data, onAdd, "AddBaseInfo");
}
export async function addBaseInfoAsync(data)
{
    const result = await postMethod(`api/BaseInfoAPI/AddBaseInfo`, data, "AddBaseInfo");
    return result;
}
export function editBaseInfo(id, name, onEdit)
{
    getMethodByCallBack(`api/BaseInfoAPI/EditBaseInfo?id=${id}&name=${name}`, cacheTypes.NoCache, onEdit, "EditBaseInfo");
}
export async function  editBaseInfoAsync(id, name)
{
    const result = await getMethod(`api/BaseInfoAPI/EditBaseInfo?id=${id}&name=${name}`, cacheTypes.NoCache, "EditBaseInfo");
    return result;
}